/**
 * Страница лицензий
 *
 * @param {Object} params
 * @param {String} params.citySelectInput - выбор города
 * @param {String} params.addresses - выбор адреса клиники
 * @param {String} params.clinics - блок лицензий для клиник
 */
$.fn.licensesFilter = function (params) {
    const $self = $(this);
    const $citySelectInput = $self.find(params.citySelectInput);
    const $addresses = $self.find(params.addresses);
    const $clinics = $self.find(params.clinics);

    /**
     * Выбор города
     */
    $citySelectInput.on('change', function () {
        var $addressesViews = $self.find('.c-select-option');
        var valueCity = Number($(this).val());
        $addressesViews.filter('[data-value="0"]').trigger('click');

        filter(valueCity);
    });

    /**
     * Выбор адреса клиники
     */
    $self.on('click', '.c-select-option', function () {
        var cityId = Number($self.find('select.js-select-filter > option[value="0"]').data('city-id'));
        var clinicId = Number($self.find('.c-select-option.active').data('value'));

        filter(cityId, clinicId);
    });

    /**
     * Фильтр клиник по городу и адресу
     *
     * @param city
     * @param clinic
     */
    const filter = function (city = 0, clinic = 0) {
        var $addressesViews = $self.find('.c-select-option');
        $self.find('select.js-select-filter > option[value="0"]').data('cityId', city);
        $addressesViews.show();
        $clinics.show();

        $addresses.each(function () {
            var cityId = Number($(this).data('city-id'));
            if (cityId !== city && city !== 0) {
                $addressesViews.filter('[data-value="' + $(this).val() + '"]').hide();
            }
        });

        $clinics.each(function () {
            var cityId = Number($(this).data('city-id'));
            var clinicId = Number($(this).data('clinic-id'));

            if (cityId !== city && city !== 0) {
                $(this).hide();
            }

            if (clinicId !== clinic && clinic !== 0) {
                $(this).hide();
            }
        });

    };

    return this;
};

// инициализация
const init = function () {
    $('#licenses').licensesFilter({
        citySelectInput: 'input',
        clinics: '.js-license-wrapper',
        addresses: 'select.js-select-filter > option',
    });
};

if ($('#licenses').length > 0) {
    init();
}
